export class ExperienceModel {
	place = '';
	period = '';
	address = '';
	position = '';
	duties = '';
	significant = '';

	constructor(
		place,
		period,
		address,
		position,
		duties,
		significant
	) {
		this.place = place || '';
		this.period = period || '';
		this.address = address || '';
		this.position = position || '';
		this.duties = duties || '';
		this.significant = significant || '';
	}
}